import { render, staticRenderFns } from "./departmentsPlatform.vue?vue&type=template&id=728f9a9f&scoped=true"
import script from "./departmentsPlatform.vue?vue&type=script&lang=js"
export * from "./departmentsPlatform.vue?vue&type=script&lang=js"
import style0 from "./departmentsPlatform.vue?vue&type=style&index=0&id=728f9a9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728f9a9f",
  null
  
)

export default component.exports